



// export const RABBIT_URL = 'wss://dev-su.eda1.ru:15673/ws';
// export const RABBIT_LOGIN = 'accounting';
// export const RABBIT_PASSWORD = 'hjhgH2Jhfgh3g';





export const RABBIT_URL = 'wss://rabbit.eda1.ru:15673/ws';
export const RABBIT_LOGIN = 'accounting';
export const RABBIT_PASSWORD = 'gPHvvbmG_fby';
